<template>
  <div class="flex-info" :style="styleObj">
    <div class="flex-info-dot"></div>
    <div class="flex-info-box">
      <slot></slot>
      <svg class="arrow" viewBox="0 0 20 10">
        <path d="M0 0 L10 10 L20 0 Z"/>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "FlexInfo",
  props: {
    left: {
      default: "0"
    },

    top: {
      default: "0"
    }

  },

  computed: {
    styleObj: function(){
      return {
        left: this.left,
        top: this.top
      }
    }
  }
}
</script>

<style>
  .flex-info {
    position: absolute;
  }

  .flex-info-dot {
    width: 2em;
    height: 2em;

  }
</style>

<style scoped>



  .flex-info-box {
    padding: 1.5em;
    background-color: white;
    width: 18em;
    display: none;
    font-size: 0.9em;
    position: absolute;
    bottom: 2em;
    transform: translateX(-50%);
    left: 50%;
    line-height: 1.5em;
    border-radius: 3px;
    border: 1px solid #DDD;
    box-shadow: 0 1px 5px rgba(0,0,0,0.2);

  }

  .arrow {
    width: 2em;
    height: 1em;
    fill: white;
    position: absolute;
    bottom: -1em;
    left: 50%;
    transform: translateX(-50%);
  }



  .flex-info:hover .flex-info-box {
    display: block;

  }

</style>